"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../Schema/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ReferenceField extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      parentId: undefined,
      referenceId: undefined
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (prevProps.schema !== this.props.schema) {}
    });

    _defineProperty(this, "onChange", formData => {
      const _this$props = this.props,
            schema = _this$props.schema,
            registry = _this$props.registry;
      const _action = formData._action,
            referenceId = formData.referenceId,
            reference = formData.reference; // if reference and no referenceId, action = "create"

      if (!referenceId) {
        formData._action = "create";
      }

      if (!reference.uniqueId) {
        formData.reference._action = "create";
      }

      const newFormData = (0, _utils.getDefaultFormState)(schema, formData);

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }
    });

    _defineProperty(this, "onDelete", () => {
      const formData = this.props.formData;
      console.log('ref:onDelete');
      this.onChange(_extends({}, formData, {
        _action: "delete"
      }));
    });

    _defineProperty(this, "onRestore", () => {
      const formData = this.props.formData;
      console.log('ref:onRestore');
      this.onChange(_extends({}, formData, {
        _action: "restore"
      }));
    });

    _defineProperty(this, "onDialog", () => {
      const _this$props2 = this.props,
            id = _this$props2.id,
            schema = _this$props2.schema,
            uiSchema = _this$props2.uiSchema,
            formData = _this$props2.formData,
            formContext = _this$props2.formContext,
            onChange = _this$props2.onChange;

      if (formContext.onDialog) {
        formContext.onDialog({
          id: id,
          type: "reference",
          schema: schema,
          uiSchema: uiSchema,
          formData: formData,
          onChange: onChange
        });
      }
    });

    _defineProperty(this, "onEditReference", () => {
      const _this$props3 = this.props,
            id = _this$props3.id,
            schema = _this$props3.schema,
            uiSchema = _this$props3.uiSchema,
            formData = _this$props3.formData,
            formContext = _this$props3.formContext,
            onChange = _this$props3.onChange;

      if (formContext.onEditReference) {
        formContext.onEditReference({
          id: id,
          type: "reference",
          schema: schema,
          uiSchema: uiSchema,
          formData: formData,
          onChange: onChange
        });
      }
    });

    _defineProperty(this, "onSettingsChange", (name, value) => {
      const _this$props4 = this.props,
            formData = _this$props4.formData,
            onChange = _this$props4.onChange;
      onChange(_extends({}, formData, {
        content: _extends({}, formData.content, {
          [name]: value
        })
      }));
    });

    _defineProperty(this, "getUiPreview", () => {
      return {
        "select": {
          "_action": "_action",
          "type": "type",
          "title": "title",
          "description": "description",
          "imageUrl": "imageUrl",
          "status": "status",
          "referenceId": "referenceId",
          "reference": "reference"
        },

        prepare({
          formData
        }) {
          const _action = formData._action,
                reference = formData.reference,
                referenceId = formData.referenceId;
          let status = reference && reference.status;

          if (_action === "delete") {
            status = "trash";
          }

          return {
            _action: _action,
            type: reference && reference.documentType,
            title: reference && reference.title,
            description: reference && reference.description,
            imageUrl: reference && reference.imageUrl,
            status: status,
            referenceId: referenceId,
            reference: reference
          };
        }

      };
    });

    _defineProperty(this, "getUiReference", () => {
      const uiSchema = this.props.uiSchema;
      const uiReference = uiSchema && uiSchema.reference || {};
      const uiOptions = (0, _utils.getUiOptions)(uiReference);
      return _extends({
        "ui:title": "Referanse" || uiOptions.title,
        "ui:options": {
          "label": uiOptions.label || false
        }
      }, uiReference);
    });

    _defineProperty(this, "getUiContent", () => {
      const uiSchema = this.props.uiSchema;
      const uiContent = uiSchema && uiSchema.content || {};
      const uiOptions = (0, _utils.getUiOptions)(uiContent);
      return _extends({
        "ui:title": "Innhold" || uiOptions.title,
        "ui:options": {
          "label": uiOptions.label || false
        }
      }, uiContent);
    });

    _defineProperty(this, "getUiSchema", () => {
      const _this$props5 = this.props,
            formData = _this$props5.formData,
            schema = _this$props5.schema,
            uiSchema = _this$props5.uiSchema,
            defaultOptions = _this$props5.defaultOptions;
      let uiOptions = (0, _utils.getUiOptions)(uiSchema);
      let fieldset = uiOptions.fieldset || [];

      if (!uiOptions.fieldset && schema.properties) {
        Object.keys(schema.properties).map(name => {
          const type = schema.properties[name] && schema.properties[name].type || undefined;

          if (type === "object") {
            fieldset.push(name);
          }
        });
      } // add navigation


      uiOptions.fieldset = fieldset;

      if (fieldset.length > 1) {
        uiOptions.nav = true;
      } // layout


      if (!uiOptions.layout) {
        uiOptions.layout = "module";
      } // deletable + restorable


      if (formData && formData.referenceId) {
        uiOptions.deletable = true;
        uiOptions.restorable = true;
      } // buttons


      let uiButtons = uiOptions.buttons || ["save"];

      if (formData && formData.reference && formData.reference.uniqueId) {
        uiButtons.push({
          label: "Edit reference",
          onClick: this.onEditReference
        });
      } else {
        uiButtons.push({
          label: "Edit reference",
          disabled: "true"
        });
      } // getUiSettings


      let uiSettings;

      if (schema.properties.content && uiOptions.settings) {
        uiSettings = (0, _utils.getUiSettings)({
          formData: formData && formData.content || {},
          schema: schema.properties.content,
          uiSchema: _extends({}, uiOptions.content, {
            "ui:settings": uiOptions.settings
          }),
          onSettingsChange: this.onSettingsChange
        });
      }

      return {
        "ui:options": _extends({}, defaultOptions, {}, uiOptions),
        "reference": this.getUiReference(),
        "content": this.getUiContent(),
        "ui:preview": this.getUiPreview(),
        "ui:settings": uiSettings,
        "ui:buttons": uiButtons
      };
    });

    _defineProperty(this, "getRegistry", () => {
      const registry = this.props.registry;
      return _extends({}, registry, {
        formContext: _extends({}, registry.formContext, {
          onDelete: this.onDelete,
          onRestore: this.onRestore
        })
      });
    });
  }

  render() {
    const _this$props6 = this.props,
          schema = _this$props6.schema,
          formData = _this$props6.formData;
    const registry = this.getRegistry();
    const uiSchema = this.getUiSchema();
    const ObjectField = registry.fields.ObjectField;
    const newFormData = (0, _utils.getDefaultFormState)(schema, formData);
    return _react.default.createElement(ObjectField, _extends({}, this.props, {
      registry: registry,
      uiSchema: uiSchema,
      formData: newFormData,
      onChange: this.onChange
    }));
  }

}

_defineProperty(ReferenceField, "defaultProps", {
  model: "documents",
  formData: {
    referenceId: undefined,
    referenceType: undefined,
    reference: {
      uniqueId: undefined,
      documentType: undefined,
      title: undefined,
      _action: undefined
    },
    _action: undefined
  },
  defaultOptions: {
    "removable": true,
    "editable": true
  }
});

var _default = ReferenceField;
exports.default = _default;
module.exports = exports.default;